import React, { useState } from 'react';
import PropTypes from 'prop-types';

const styles = {
    container: {
        borderBottom: '1px solid #000',
    },
    button: {
        cursor: 'pointer',
        border: 'none',
        backgroundColor: 'transparent',
        outline: 'none',
    },
    showHideIcon: {
        lineHeight: '1.5rem',
        cursor: 'pointer',
    },
};

const FilterBlock = ({ label, children, defaultExpanded = false }) => {
    const [expanded, setExpanded] = useState(defaultExpanded);

    return (
        <div className="filter-section" style={styles.container}>
            <button
                className="display7 bold w-100 px-0 py-2"
                style={styles.button}
                onClick={() => setExpanded(!expanded)}
                onKeyDown={() => setExpanded(!expanded)}
                type="button"
            >
                <span className="d-flex justify-content-between text-left" style={{ alignItems: 'start' }}>
                    {label}
                    <span style={styles.showHideIcon}>{expanded ? '-' : '+'}</span>
                </span>
            </button>

            <div className="overflow-hidden" style={{ height: expanded ? 'auto' : 0, overflow: 'hidden' }}>
                {children}
            </div>
        </div>
    );
};

FilterBlock.propTypes = {
    label: PropTypes.string.isRequired,
    children: PropTypes.any.isRequired,
    defaultExpanded: PropTypes.bool,
};

export default FilterBlock;
